var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('polygon',{attrs:{"points":"10.4,23.2 0,13.8 3.2,10.2 9.9,16.3 20.3,3.6 24,6.7 "}})])}
var staticRenderFns = []

export { render, staticRenderFns }